const MMIR_DOMAIN_NAME = "mmir.agi.amazon.dev";
const CURRENT_URL = window.location.origin;
const MMIR_UI_BETA_USER_LDAP_GROUP_NAME = 'mmir-ui-beta-testers';

export const formatDate = (date) => {
  if (!date) return 'Unknown';
  let dateObj = new Date(date);
  if (dateObj.getFullYear() <= 1970) return 'Unknown';
  return dateObj.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export const isLicensedImage = (sourceType) => {
  return ['getty', 'getty images', 'imdb', 'wikipedia'].includes(sourceType.toLowerCase());
}

export const getImageCreationDate = (sourceType, creationDate, lastUpdatedDate, acquiredAtDate, publishedAtDate) => {
  if (isLicensedImage(sourceType)) {
    return [creationDate, lastUpdatedDate, acquiredAtDate].find(d => typeof d !== 'undefined')
  } else {
    return [publishedAtDate, acquiredAtDate].find(d => typeof d !== 'undefined')
  }
}

export const openUrlInNewTab = (url) => {
  window.open(url, "_blank", "noreferrer");
};

export const getStage = () => {
  if (CURRENT_URL.includes(MMIR_DOMAIN_NAME)) {
    return "PROD";
  }
  if (CURRENT_URL.includes("beta")) {
    return "BETA";
  }
  if (CURRENT_URL.includes("gamma")) {
    return "GAMMA";
  }
  if (CURRENT_URL.includes("prod")) {
    return "PROD";
  }
  return "DEV";
}

export const getRegion = (stage) => {
  if (CURRENT_URL.includes(MMIR_DOMAIN_NAME)) {
    return "us-east-1";
  }
  if (stage === "DEV" || stage === "BETA") {
    return "us-west-2";
  }
  if (CURRENT_URL.includes("zaz")) {
    return "eu-south-2";
  }
  if (CURRENT_URL.includes("dub")) {
    return "eu-west-1";
  }

  if (CURRENT_URL.includes("iad")) {
    return "us-east-1";
  }

  if (CURRENT_URL.includes("pdx")) {
    return "us-west-2";
  }
  console.debug("Couldn't determine region. Defaulting to PDX");
  return "us-west-2"
}

export const isProdNA = (stage, region) => {
  return stage === "PROD" && region === "us-east-1";  
}

export const suggestedQueries = () => {
  return [{
    "query": "who won the 2025 australian open men's single",
    "answer": "Jannik Sinner emerged victorious in the 2025 Australian Open men's singles final, securing his second consecutive title at the event. The World No. 1 defeated Alexander Zverev in straight sets with a score of 6-3, 7-6 (7-4), 6-3. This win marks Sinner's third Grand Slam title overall and extends his impressive streak of 21 consecutive wins at hard-court Grand Slams. Sinner's performance throughout the tournament was dominant, dropping only two sets across seven matches. His victory over Zverev solidifies his position as one of the top players in the world, with a record of 47 wins in his first 50 matches as World No. 1, tying him with legends Bjorn Borg and Jimmy Connors. Alexander Zverev, despite a strong showing, remains in search of his first Grand Slam title, having now lost in three major finals. His journey to the final included a semifinal match where Novak Djokovic retired due to injury, allowing Zverev to advance. Sinner's back-to-back wins at the Australian Open place him among an elite group of players, including Jim Courier and Rafael Nadal, who have achieved similar feats. His continued success at major tournaments underscores his growing legacy in the sport"
  }, {
    "query": "what are the main ingredients in guacamole",
    "answer": "The main ingredients in guacamole typically include ripe avocados, which serve as the base and provide creaminess, and lime juice, which adds acidity and helps prevent the avocado from browning. Other common ingredients are finely chopped onions, which contribute a mild sharpness, and minced garlic, offering a robust flavor. Additionally, small diced tomatoes are often included for sweetness and juiciness, and cilantro is added for its fresh, herbaceous taste. Salt is essential for enhancing all the flavors, and some variations may include jalapeño peppers for a spicy kick. These ingredients together create the classic, flavorful dip known as guacamole."
  }, {
    "query": "who won the oscar for best actor in 2025",
    "answer": "Adrien Brody won the Oscar for Best Actor in 2025 for his role in 'The Brutalist'. This marks Brody's second Oscar win in the Best Actor category, having previously won for his performance in 'The Pianist' in 2002. Brody's win in 2025 maintains his status as the youngest actor to have ever won a Best Actor Oscar, a record he set with his first win at the age of 29. Brody's portrayal of a Holocaust survivor and Hungarian architect who emigrates to the United States in 'The Brutalist' was widely acclaimed. His acceptance speech emphasized the fragility of the acting profession and the importance of perspective, regardless of career accomplishments."
  }];
}

export const isPartOfBetaUserGroup = (userAuthenticationData) => {
  try {
    let ldapGroups = userAuthenticationData.getSignInUserSession().getIdToken().decodePayload()["custom:LDAP_GROUP"];
    return ldapGroups.includes(MMIR_UI_BETA_USER_LDAP_GROUP_NAME);
  } catch (e) {
    console.error(e);
    return false;
  }
}

// ImageV2.ConfidenceBin from
// AlexaMultimediaDiscoveryInterface/src/com/amazon/amd/model/image/ImageV2.java.
// UNKNOWN is common rather than exceptional: AMD uses it for images that skip the
// caption-reranker (EBR-only, image-URL, parent-URL, GetImages, MMIR 2.0), when the
// caller opts out of binning, or when the threshold map is missing.
export const CONFIDENCE_BINS = ['HIGH', 'MEDIUM', 'LOW', 'UNKNOWN'];

/**
 * True when the image belongs in the selected confidence bin.
 * A missing bin counts as UNKNOWN: AMD defaults it on the wire, but V1/UAC responses and
 * legacy cache entries can still arrive without it, and silently dropping those would make
 * the filter lose results rather than narrow them.
 */
export const matchesConfidenceBin = (image, selectedBin) => {
  if (!selectedBin || selectedBin === 'All' || selectedBin === 'Confidence') return true;
  return ((image && image.confidence_bin) || 'UNKNOWN') === selectedBin;
};
